import SiteChrome from "@chrome/SiteChrome";
import { HtmlPageTitle } from "@components/HtmlPageTitle";
import { MetaDescription } from "@components/MetaDescription";
import NewsletterPage from "@components/newsletter/NewsletterPage";
import { SiteHtmlPageTitle } from "@content/en/HtmlTitle";

const NewsletterLandingPage = () => (
  <SiteChrome>
    <HtmlPageTitle title={`Blues Dev News - ${SiteHtmlPageTitle}`} />
    <MetaDescription description="The official monthly Blues newsletter. Written by developers, for developers." />
    <NewsletterPage />
  </SiteChrome>
);

export default NewsletterLandingPage;
